export default {
  init() {
    // Conditionally show fields.
    // INVOICE
    const $invoiceFields = $('.show-if-invoice')

    function toggleInvoiceFields( radioVal ) {
      $invoiceFields
        .toggle(radioVal === 'invoice')
          .find('input')
          .attr(
            'required',
            function() {
              return radioVal === 'invoice' ? '' : null
            }
          )
    }

    const $saleDocRadios = $('input[name="billing_sale_document"]')

    // If nothing is selected, selete the first option.
    if (!$saleDocRadios.is(':checked')) {
      $saleDocRadios.first().prop("checked", true)
    }

    $saleDocRadios.change(function() {
      toggleInvoiceFields($(this).val())
    })

    toggleInvoiceFields($saleDocRadios.filter(':checked').val())

    // GIFT
    const $giftFields = $('.show-if-gift')

    function toggleGiftFields(checked) {
      $giftFields
        .toggle(checked)
          .find('input')
          .attr(
            'required',
            function() {
              return checked ? '' : null
            }
          )
    }

    const $giftCheckbox = $('input[name="additional_order_gift"]')

    $giftCheckbox.change(function() {
      toggleGiftFields($giftCheckbox.is(':checked'))
    })

    toggleGiftFields($giftCheckbox.is(':checked'))

    // ORDER NOTES
    const $orderNotesField = $('#order_comments')
    const $allGiftFields = $('input, textarea').filter('[name^="additional_order_gift"]')

    const fillOrderNotes = function() {
      if (!$('#additional_order_gift').is(':checked')) {
        $orderNotesField.val('')
        return
      }

      let valueToFill = ''

      $allGiftFields
        .each(function(i, el) {
          if (i > 0) {
            valueToFill += `\n`
          }

          const $el = $(el)

          if ($el.is('[name="additional_order_gift"]')) {
            valueToFill += $el.closest('label').find('.optional').remove().end().text().trim() + ': ' + window.app.i18n.yes + '. '
          } else {
            valueToFill += $(`label[for="${$el.attr('id')}"]`).find('.optional').remove().end().text().trim() + ': ' + $el.val() + '. '
          }

        })

      $orderNotesField.val(valueToFill)
    }

    $allGiftFields.change(fillOrderNotes)
    fillOrderNotes()


    // Cancel checkout login message from being converted by horrorpacks woocommerce-messages.
    if (typeof window.hpBeforeCreateWCMessage !== 'undefined' && Array.isArray(window.hpBeforeCreateWCMessage)) {
      window.hpBeforeCreateWCMessage.push((message) => {
        const $message = $(message)

        // Checks if the message is the returning customer text..
        if (
          $message.text().includes(window.app.i18n.returningCustomer)
          || $message.text().includes(window.app.i18n.cartEmpty)
        ) {
          return false
        }
      })
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js